'use strict';
define([
    'angular',
    'modules/keywordexplorer/search/search.controller'
], function (angular, KeywordSearchCtrl) {
    var app = angular.module('app.keywordexplorer.search', []);
    app.controller('KeywordSearchCtrl', KeywordSearchCtrl);
    return app;
});
